export const GENERAL_INFO = 'General Info';
export const USERS = 'Users';
export const AMS_SYNC = 'AMS Sync';
export const PREFERENCE_PAGE = 'Preference Page';
export const NONMEMBER_SIGNUP_FORM = 'Nonmember Signup Form';
